/**
 * Mirror of server/src/config/roles.js — kept hand-maintained because role
 * IDs are stable and small. (Don't generate them: the FE needs the ROLE
 * KEY for routing decisions before any API call has happened.)
 */
export const ROLES = {
	SUPER_ADMIN: 'SUPER_ADMIN',
	INSURANCE_ADMIN: 'INSURANCE_ADMIN',
	INSURANCE_STAFF: 'INSURANCE_STAFF',
	SUPPLIER_ADMIN: 'SUPPLIER_ADMIN',
	SUPPLIER_STAFF: 'SUPPLIER_STAFF',
	MECHANIC: 'MECHANIC',
} as const;

export type RoleKey = keyof typeof ROLES;

export const ROLE_IDS: Record<RoleKey, number> = {
	SUPER_ADMIN: 1,
	INSURANCE_ADMIN: 10010,
	INSURANCE_STAFF: 10012,
	SUPPLIER_ADMIN: 10013,
	SUPPLIER_STAFF: 10014,
	MECHANIC: 10020,
};

export const ROLE_BY_ID: Record<number, RoleKey> = Object.entries(ROLE_IDS).reduce(
	(acc, [key, id]) => ({ ...acc, [id]: key as RoleKey }),
	{}
);

export function isInsurance(role?: RoleKey | null): boolean {
	return role === 'INSURANCE_ADMIN' || role === 'INSURANCE_STAFF';
}
export function isSupplier(role?: RoleKey | null): boolean {
	return role === 'SUPPLIER_ADMIN' || role === 'SUPPLIER_STAFF';
}
export function isMechanic(role?: RoleKey | null): boolean {
	return role === 'MECHANIC';
}
export function isAdmin(role?: RoleKey | null): boolean {
	return (
		role === 'SUPER_ADMIN' ||
		role === 'INSURANCE_ADMIN' ||
		role === 'SUPPLIER_ADMIN'
	);
}

/** Where to send the user after login based on their role. */
export function homePathFor(role?: RoleKey | null): string {
	if (!role) return '/login';
	if (isInsurance(role) || role === 'SUPER_ADMIN') return '/requests';
	if (isSupplier(role)) return '/supplier';
	if (isMechanic(role)) return '/mechanic';
	return '/';
}
